const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnMicXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.215 125.6a4.5 4.5 0 0 0 4.444-4.541v-4.026a4.446 4.446 0 1 0-8.89 0v4.026a4.5 4.5 0 0 0 4.446 4.541zm-2.4-8.568a2.4 2.4 0 1 1 4.807 0v4.026a2.4 2.4 0 1 1-4.807 0zm7.492 14.416a1.032 1.032 0 0 1-1.021 1.043H596.1a1.043 1.043 0 0 1 0-2.086h3.09v-2.125a6.092 6.092 0 0 1-5.479-5.787 1.021 1.021 0 1 1 2.041 0c0 2.085 2 3.78 4.459 3.78s4.459-1.7 4.459-3.78a1.021 1.021 0 1 1 2.041 0 6.092 6.092 0 0 1-5.479 5.787v2.128h3.047a1.032 1.032 0 0 1 1.021 1.043z",
    transform: "translate(-587.715 -110.494)",
    style: {
      fill: "current"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMicXs);
export default __webpack_public_path__ + "static/media/btn-mic-xs.e5ded720864ce9c199e1258460b96c34.svg";
export { ForwardRef as ReactComponent };